import React, { PropTypes } from 'react';
import { FormattedMessage } from 'react-intl';
import { PrimaryButton } from '@bibliocommons/base-buttons';

export default function PauseHoldButton({ handleClick, isLoading, disabled }) {
  return (
    <PrimaryButton
      isLoading={isLoading}
      disabled={disabled}
      className="cp-pause-hold-button"
      handleClick={handleClick}>
      <FormattedMessage id="pause_hold" />
    </PrimaryButton>
  );
}

PauseHoldButton.propTypes = {
  handleClick: PropTypes.func,
  isLoading: PropTypes.bool,
  disabled: PropTypes.bool
};



// WEBPACK FOOTER //
// ./app/components/borrowing/holds/PauseHoldButton/PauseHoldButton.jsx